import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const Section = styled.div<{ $separated?: boolean }>`
    display: flex;
    flex-direction: column;
    flex: none;
    gap: 0;
    overflow-y: visible;
    padding: ${theme.space[4]};
    margin-bottom: 0;
    border-bottom: ${(props) => (props.$separated ? `1px solid ${theme.colors.border.muted}` : 'none')};
`;
